import { RefObject } from 'react';
import { DataCategoryModulesRef } from '../../health-data-categories/data-category-modules';

/**
 * Scrolls to a specific category using the DataCategoryModules ref
 * @param categoryRef - Ref to the DataCategoryModules component
 * @param categoryName - Name of the category to scroll to
 */
export const scrollToCategory = (
  categoryRef: RefObject<DataCategoryModulesRef>,
  categoryName: string
) => {
  try {
    if (!categoryRef.current) {
      console.warn('Category modules ref is not available');
      return;
    }

    categoryRef.current.scrollToAndExpandCategory(categoryName);
  } catch (error) {
    console.error('Error scrolling to category:', error, { categoryName });
  }
};
